/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import i18next from 'i18next';
import { merge } from 'lodash';
import store from '../../redux/store';
import { showAlertError } from '../../redux/features/alerts/alerts.slice';
import { startApplicationLoading, stopApplicationLoading } from '../../redux/features/application/application.slice';
import { createMessage } from '../../redux/features/alerts/alerts.helper';
import { getMessageFromError } from '../../redux/helpers/thunk.helpers';
import { postSignOutThunk } from '../../redux/features/auth/auth.thunk';

const defaultOptions = {
  showAlertOnError: true,
  errorMessage: undefined,
  showApplicationLoading: false,
  onSuccess: undefined,
  onError: undefined,
};

function isCancelledError(error) {
  return error?.code === 'ERR_CANCELED';
}

export function handleCancelError(error) {
  if (!isCancelledError(error)) {
    throw error;
  }
}

export const callApi = (callback, options = defaultOptions) => async (...params) => {
  let _errorMessage = i18next.t('error.page.generic.message');
  // resources need to be loaded in order to translate the default message, otherwise fallback to hardcoded message
  if (!_errorMessage || _errorMessage === 'error.page.generic.message') {
    _errorMessage = i18next.t('messages.contact.local.support');
  }
  const _options = merge(
    {
      errorMessage: _errorMessage,
    },
    options,
  );

  try {
    if (_options.showApplicationLoading) {
      store.dispatch(startApplicationLoading());
    }
    const apiResponse = await callback(...params);

    if (_options.onSuccess) {
      _options.onSuccess(apiResponse);
    }

    return apiResponse;
  } catch (error) {
    if (isCancelledError(error)) {
      throw error;
    } else if (_options.showAlertOnError) {
      store.dispatch(showAlertError(createMessage(await getMessageFromError(error), error)));
    }

    if (error?.response?.status === 401 || error?.response?.status === 403) {
      store.dispatch(postSignOutThunk());
    }

    if (_options.onError) {
      _options.onError(error);
    }

    return {};
  } finally {
    if (_options.showApplicationLoading) {
      store.dispatch(stopApplicationLoading());
    }
  }
};
